/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TipoViaturaCriteriaDto } from '../models/tipo-viatura-criteria-dto';
import { TipoViaturaDto } from '../models/tipo-viatura-dto';
import { TipoViaturaFormDto } from '../models/tipo-viatura-form-dto';
import { TipoViaturaPageDto } from '../models/tipo-viatura-page-dto';

@Injectable({
  providedIn: 'root',
})
export class TiposViaturaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTiposViatura
   */
  static readonly GetTiposViaturaPath = '/tipos-viatura';

  /**
   * Pesquisar tipos de viatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTiposViatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposViatura$Response(params?: {
    criteria?: TipoViaturaCriteriaDto;
  }): Observable<StrictHttpResponse<TipoViaturaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposViaturaService.GetTiposViaturaPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoViaturaPageDto>;
      })
    );
  }

  /**
   * Pesquisar tipos de viatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTiposViatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTiposViatura(params?: {
    criteria?: TipoViaturaCriteriaDto;
  }): Observable<TipoViaturaPageDto> {

    return this.getTiposViatura$Response(params).pipe(
      map((r: StrictHttpResponse<TipoViaturaPageDto>) => r.body as TipoViaturaPageDto)
    );
  }

  /**
   * Path part for operation createTipoViatura
   */
  static readonly CreateTipoViaturaPath = '/tipos-viatura';

  /**
   * Criar tipo de viatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTipoViatura()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoViatura$Response(params?: {

    /**
     * apiRequest
     */
    body?: TipoViaturaFormDto
  }): Observable<StrictHttpResponse<TipoViaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposViaturaService.CreateTipoViaturaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoViaturaDto>;
      })
    );
  }

  /**
   * Criar tipo de viatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTipoViatura$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTipoViatura(params?: {

    /**
     * apiRequest
     */
    body?: TipoViaturaFormDto
  }): Observable<TipoViaturaDto> {

    return this.createTipoViatura$Response(params).pipe(
      map((r: StrictHttpResponse<TipoViaturaDto>) => r.body as TipoViaturaDto)
    );
  }

  /**
   * Path part for operation getTipoViatura
   */
  static readonly GetTipoViaturaPath = '/tipos-viatura/{id}';

  /**
   * Obter tipo de viatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTipoViatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoViatura$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoViaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposViaturaService.GetTipoViaturaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoViaturaDto>;
      })
    );
  }

  /**
   * Obter tipo de viatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTipoViatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTipoViatura(params: {
    id: number;
  }): Observable<TipoViaturaDto> {

    return this.getTipoViatura$Response(params).pipe(
      map((r: StrictHttpResponse<TipoViaturaDto>) => r.body as TipoViaturaDto)
    );
  }

  /**
   * Path part for operation updateTipoViatura
   */
  static readonly UpdateTipoViaturaPath = '/tipos-viatura/{id}';

  /**
   * Atualizar tipo de viatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTipoViatura()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoViatura$Response(params: {
    id: number;
    body?: TipoViaturaFormDto
  }): Observable<StrictHttpResponse<TipoViaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposViaturaService.UpdateTipoViaturaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoViaturaDto>;
      })
    );
  }

  /**
   * Atualizar tipo de viatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTipoViatura$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTipoViatura(params: {
    id: number;
    body?: TipoViaturaFormDto
  }): Observable<TipoViaturaDto> {

    return this.updateTipoViatura$Response(params).pipe(
      map((r: StrictHttpResponse<TipoViaturaDto>) => r.body as TipoViaturaDto)
    );
  }

  /**
   * Path part for operation ativarTipoViatura
   */
  static readonly AtivarTipoViaturaPath = '/tipos-viatura/{id}/ativar';

  /**
   * Ativar Tipo Viatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarTipoViatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoViatura$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoViaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposViaturaService.AtivarTipoViaturaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoViaturaDto>;
      })
    );
  }

  /**
   * Ativar Tipo Viatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarTipoViatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarTipoViatura(params: {
    id: number;
  }): Observable<TipoViaturaDto> {

    return this.ativarTipoViatura$Response(params).pipe(
      map((r: StrictHttpResponse<TipoViaturaDto>) => r.body as TipoViaturaDto)
    );
  }

  /**
   * Path part for operation desativarTipoViatura
   */
  static readonly DesativarTipoViaturaPath = '/tipos-viatura/{id}/desativar';

  /**
   * Desativar TipoViatura.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarTipoViatura()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoViatura$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<TipoViaturaDto>> {

    const rb = new RequestBuilder(this.rootUrl, TiposViaturaService.DesativarTipoViaturaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TipoViaturaDto>;
      })
    );
  }

  /**
   * Desativar TipoViatura.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarTipoViatura$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarTipoViatura(params: {
    id: number;
  }): Observable<TipoViaturaDto> {

    return this.desativarTipoViatura$Response(params).pipe(
      map((r: StrictHttpResponse<TipoViaturaDto>) => r.body as TipoViaturaDto)
    );
  }

}
